import { Injectable } from '@angular/core';
// import { MatSnackBar } from '@angular/material/snack-bar';

import { HttpResponseModel } from '../base-http.service';


@Injectable({
  providedIn: 'root'
})
export class ResponseHandlerService {

  constructor(
    //private snackBar: MatSnackBar
  ) { }

  validateResponse<T>(response: HttpResponseModel<T>): T | null {
    if (response.status === 'success' && response.data) {
      if (response.count) {
        const result = { data: response.data, count: response.count };
        return result as T;
      }
      return response.data;
    } else if (response.status === 'success' && response.message) {
      this.showSuccessMessage(response.message);
      return response.status as string as T;
    }
    else {
      this.showMessage(response.message || 'Unexpected error occurred.');
      return null;
    }
  }

  private showMessage(message: string): void {
    // this.snackBar.open(message, 'Close', {
    //   duration: 3000,
    // });
  }

  private showSuccessMessage(message: string): void {
    // this.snackBar.open(message, 'Close', {
    //   duration: 3000,
    //   panelClass: ['success-snackbar']
    // });
  }
}
